import React from "react";
import { useNavigate } from "react-router-dom";
import BlockchainBackground from "../Components/BlockchainBackground";
import "../styles/BlockchainBackground.css";
import logo from "../images/logo.png";
import { useAuth } from "@clerk/clerk-react";


const LandingPage = () => {
    const navigate = useNavigate();
    const {isSignedIn} = useAuth()

    const handleLoginClick = () => {
        console.log("Login clicked");
        navigate('/LogInPage')



    };

    const handleSignupClick = () => {
        console.log("Signup clicked");
        if (isSignedIn){
            navigate('/AdminDashboard')
        }else{
            navigate('/SignUpPage');
        }

    };

    return (
        <div className="relative h-screen w-screen overflow-hidden bgColor font-[Montserrat]">
            <div className="absolute inset-0 z-0 pointer-events-none">
                <BlockchainBackground />
            </div>

            {/* Login and Signup buttons with responsive design */}
            <div className="absolute top-4 right-4 md:top-6 md:right-8 flex flex-col md:flex-row space-y-2 md:space-y-0 md:space-x-4 z-50">
                <button
                    onClick={handleLoginClick}
                    className="relative overflow-hidden w-24 md:w-full block text-center px-4 md:px-8 py-2 md:py-3 text-sm md:text-lg font-medium text-[#154c79] bg-white rounded-full transition-all duration-300 ease-in-out group hover:translate-y-[-2px] hover:shadow-lg shadow-md"
                    style={{ pointerEvents: 'auto' }}
                >
                    <span className="relative z-10 transition-colors duration-300 ease-in-out group-hover:text-white">


                        Login


                    </span>
                    <span className="absolute inset-0 bg-[#154c79] scale-x-0 origin-left transition-transform duration-500 ease-in-out group-hover:scale-x-100"></span>
                </button>



                <button
                    onClick={handleSignupClick}
                    className="relative overflow-hidden w-24 md:w-full block text-center px-4 md:px-8 py-2 md:py-3 text-sm md:text-lg font-medium text-[#154c79] bg-white rounded-full transition-all duration-300 ease-in-out group hover:translate-y-[-2px] hover:shadow-lg shadow-md"
                    style={{ pointerEvents: 'auto' }}
                >
                    <span className="relative z-10 transition-colors duration-300 ease-in-out group-hover:text-white">
                        Signup
                    </span>
                    <span className="absolute inset-0 bg-[#154c79] scale-x-0 origin-left transition-transform duration-500 ease-in-out group-hover:scale-x-100"></span>
                </button>
            </div>

            <div className="relative flex flex-col items-center justify-center h-full px-4 text-center z-10 pointer-events-none">
                {/* Keeping the logo exactly as in the original */}
                <img src={logo} alt="Block Ballot Logo" className="h-24 md:h-32 mb-4 animate-fade-in" />
                <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-800 animate-fade-in">Welcome to BlockBallot</h1>
                <p className="text-base sm:text-lg text-gray-600 mt-2 mb-6 animate-fade-in max-w-md mx-auto">
                    The Future of Voting.
                </p>
            </div>

            {/* Footer */}
            <footer className="absolute bottom-2 md:bottom-4 left-0 w-full text-gray-500 text-xs md:text-sm text-center z-10">
                &copy; BlockBallot. All Rights Reserved.
            </footer>
        </div>
    );
};

export default LandingPage;